export const MODE = 'production'; // sandbox or production
export const SANDBOX_CLIENT_ID = 'ARxeCN-6fVJHHik5k_F3GV7kELABHu5stip3rGwORkFEqNpmCnXtMtVzGJBHsmjNmo9Mc5iqv-cS-Q2d';
export const LIVE_CLIENT_ID = 'Ad2xuKTfoCvKGWwB3B6PYV6GDDOdKNSzpS4UVLCS6vPs1vmmCh7GX-JB8flaUnIPaRcD6_Bu9XRTcSDs';
export const CLIENT_ID = MODE === 'sandbox' ? SANDBOX_CLIENT_ID : LIVE_CLIENT_ID;

export default {
  MODE, SANDBOX_CLIENT_ID, LIVE_CLIENT_ID, CLIENT_ID,
};
